import type { AfterResponseHook, BeforeErrorHook, BeforeRequestHook } from "ky";
import { isHTTPError } from "ky";

import { hideLoader, showLoader } from "@/redux/actions/loader";
import store from "@/redux/store";

import type { ApiContext } from "../types";

// store.dispatch is typed as Dispatch<AnyAction> but loader actions are thunks
const dispatch: (action: any) => any = store.dispatch;

export const loaderStartHook: BeforeRequestHook = ({ options }) => {
  const context = options.context as ApiContext | undefined;

  if (context?.showLoader !== false) {
    dispatch(showLoader());
  }
};

// Runs for ALL responses including 4xx/5xx (afterResponse fires before beforeError for HTTPErrors)
export const loaderEndHook: AfterResponseHook = () => {
  dispatch(hideLoader());
};

// Only fires for network errors and timeouts — HTTPErrors already went through loaderEndHook
export const loaderErrorHook: BeforeErrorHook = ({ error }) => {
  if (!isHTTPError(error)) {
    dispatch(hideLoader());
  }

  return error;
};
